"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var model_1 = require("../data/model");
var collections_1 = require("../viewUtils/collections");
var AuthoringKind;
(function (AuthoringKind) {
    AuthoringKind["ChangeElement"] = "changeElement";
    AuthoringKind["DeleteElement"] = "deleteElement";
    AuthoringKind["ChangeLink"] = "changeLink";
    AuthoringKind["DeleteLink"] = "deleteLink";
})(AuthoringKind = exports.AuthoringKind || (exports.AuthoringKind = {}));
var AuthoringState;
(function (AuthoringState) {
    AuthoringState.empty = {
        events: [],
        index: makeIndex([]),
    };
    function set(state, change) {
        var events = change.events || state.events;
        var index = makeIndex(events);
        return tslib_1.__assign({}, state, { events: events, index: index });
    }
    AuthoringState.set = set;
    function discard(state, discarded) {
        var index = state.events.indexOf(discarded);
        if (index < 0) {
            return state;
        }
        var newElementIri = discarded.type === AuthoringKind.ChangeElement && !discarded.before
            ? discarded.after.id : undefined;
        var events = state.events.filter(function (e) {
            if (e.type === AuthoringKind.ChangeLink) {
                if (newElementIri && isLinkConnectedToElement(e.after, newElementIri)) {
                    return false;
                }
            }
            return e !== discarded;
        });
        return set(state, { events: events });
    }
    AuthoringState.discard = discard;
    function addElement(state, item) {
        var event = { type: AuthoringKind.ChangeElement, after: item };
        return AuthoringState.set(state, { events: state.events.concat([event]) });
    }
    AuthoringState.addElement = addElement;
    function addLink(state, item) {
        var event = { type: AuthoringKind.ChangeLink, after: item };
        return AuthoringState.set(state, { events: state.events.concat([event]) });
    }
    AuthoringState.addLink = addLink;
    function changeElement(state, before, after) {
        var iriChanged = after.id !== before.id;
        if (iriChanged) {
            // disallow changing IRI for existing (non-new) entities
            var isNewEntity = state.events.find(function (e) {
                return e.type === AuthoringKind.ChangeElement &&
                    e.after.id === before.id &&
                    !e.before;
            });
            if (!isNewEntity) {
                throw new Error('Cannot change IRI of already persisted entity');
            }
        }
        var previousBefore = before;
        var additional = [];
        var events = state.events.filter(function (e) {
            if (e.type === AuthoringKind.DeleteElement) {
                if (e.model.id === before.id) {
                    previousBefore = e.model;
                    return false;
                }
            }
            else if (e.type === AuthoringKind.ChangeElement) {
                if (e.after.id === before.id) {
                    previousBefore = e.before;
                    return false;
                }
            }
            else if (e.type === AuthoringKind.ChangeLink) {
                if (iriChanged && isLinkConnectedToElement(e.after, before.id)) {
                    additional.push({
                        type: AuthoringKind.ChangeLink,
                        before: e.before,
                        after: updateLinkToReferByNewIri(e.after, before.id, after.id),
                    });
                    return false;
                }
            }
            return true;
        });
        additional.unshift({
            type: AuthoringKind.ChangeElement,
            before: previousBefore,
            after: after,
        });
        return AuthoringState.set(state, { events: events.concat(additional) });
    }
    AuthoringState.changeElement = changeElement;
    function changeLink(state, before, after) {
        if (!model_1.sameLink(before, after)) {
            throw new Error('Cannot move link to another element or change its type');
        }
        var previousBefore = before;
        var events = state.events.filter(function (e) {
            if (e.type === AuthoringKind.ChangeLink) {
                if (model_1.sameLink(e.after, before)) {
                    previousBefore = e.before;
                    return false;
                }
            }
            return true;
        });
        var event = {
            type: AuthoringKind.ChangeLink,
            before: previousBefore,
            after: after,
        };
        return AuthoringState.set(state, { events: events.concat([event]) });
    }
    AuthoringState.changeLink = changeLink;
    function deleteElement(state, model) {
        var events = state.events.filter(function (e) {
            if (e.type === AuthoringKind.ChangeElement) {
                if (e.after.id === model.id) {
                    return false;
                }
            }
            else if (e.type === AuthoringKind.ChangeLink) {
                if (isLinkConnectedToElement(e.after, model.id)) {
                    return false;
                }
            }
            else if (e.type === AuthoringKind.DeleteLink) {
                if (isLinkConnectedToElement(e.model, model.id)) {
                    return false;
                }
            }
            return true;
        });
        if (!isNewElement(state, model.id)) {
            events.push({ type: AuthoringKind.DeleteElement, model: model });
        }
        return AuthoringState.set(state, { events: events });
    }
    AuthoringState.deleteElement = deleteElement;
    function deleteLink(state, target) {
        var events = state.events.filter(function (e) {
            if (e.type === AuthoringKind.ChangeLink) {
                if (model_1.sameLink(e.after, target)) {
                    return false;
                }
            }
            else if (e.type === AuthoringKind.DeleteLink) {
                if (model_1.sameLink(e.model, target)) {
                    return false;
                }
            }
            return true;
        });
        if (!isNewLink(state, target)) {
            events.push({
                type: AuthoringKind.DeleteLink,
                model: target,
            });
        }
        return AuthoringState.set(state, { events: events });
    }
    AuthoringState.deleteLink = deleteLink;
    function makeIndex(events) {
        var elements = new Map();
        var links = new collections_1.HashMap(model_1.hashLink, model_1.sameLink);
        for (var _i = 0, events_1 = events; _i < events_1.length; _i++) {
            var e = events_1[_i];
            if (e.type === AuthoringKind.ChangeElement) {
                elements.set(e.after.id, e);
            }
            else if (e.type === AuthoringKind.DeleteElement) {
                elements.set(e.model.id, e);
            }
            else if (e.type === AuthoringKind.ChangeLink) {
                links.set(e.after, e);
            }
            else if (e.type === AuthoringKind.DeleteLink) {
                links.set(e.model, e);
            }
        }
        return { elements: elements, links: links };
    }
    function isNewElement(state, elementIri) {
        var event = state.index.elements.get(elementIri);
        return event && event.type === AuthoringKind.ChangeElement && !event.before;
    }
    AuthoringState.isNewElement = isNewElement;
    function isNewLink(state, linkModel) {
        var event = state.index.links.get(linkModel);
        return event && event.type === AuthoringKind.ChangeLink && !event.before;
    }
    AuthoringState.isNewLink = isNewLink;
})(AuthoringState = exports.AuthoringState || (exports.AuthoringState = {}));
var TemporaryState;
(function (TemporaryState) {
    TemporaryState.empty = {
        elements: new Map(),
        links: new collections_1.HashMap(model_1.hashLink, model_1.sameLink),
    };
    function addElement(state, element) {
        var elements = collections_1.cloneMap(state.elements);
        elements.set(element.id, element);
        return tslib_1.__assign({}, state, { elements: elements });
    }
    TemporaryState.addElement = addElement;
    function deleteElement(state, element) {
        var elements = collections_1.cloneMap(state.elements);
        elements.delete(element.id);
        return tslib_1.__assign({}, state, { elements: elements });
    }
    TemporaryState.deleteElement = deleteElement;
    function addLink(state, link) {
        var links = state.links.clone();
        links.set(link, link);
        return tslib_1.__assign({}, state, { links: links });
    }
    TemporaryState.addLink = addLink;
    function deleteLink(state, link) {
        var links = state.links.clone();
        links.delete(link);
        return tslib_1.__assign({}, state, { links: links });
    }
    TemporaryState.deleteLink = deleteLink;
})(TemporaryState = exports.TemporaryState || (exports.TemporaryState = {}));
var ValidationState;
(function (ValidationState) {
    ValidationState.empty = createMutable();
    ValidationState.emptyElement = { loading: false, errors: [] };
    ValidationState.emptyLink = { loading: false, errors: [] };
    function createMutable() {
        return {
            elements: new Map(),
            links: new collections_1.HashMap(model_1.hashLink, model_1.sameLink),
        };
    }
    ValidationState.createMutable = createMutable;
    function setElementErrors(state, target, errors) {
        var elements = collections_1.cloneMap(state.elements);
        if (errors.length > 0) {
            elements.set(target, { loading: false, errors: errors });
        }
        else {
            elements.delete(target);
        }
        return tslib_1.__assign({}, state, { elements: elements });
    }
    ValidationState.setElementErrors = setElementErrors;
})(ValidationState = exports.ValidationState || (exports.ValidationState = {}));
function isLinkConnectedToElement(link, elementIri) {
    return link.sourceId === elementIri || link.targetId === elementIri;
}
exports.isLinkConnectedToElement = isLinkConnectedToElement;
function updateLinkToReferByNewIri(link, oldIri, newIri) {
    return tslib_1.__assign({}, link, { sourceId: link.sourceId === oldIri ? newIri : link.sourceId, targetId: link.targetId === oldIri ? newIri : link.targetId });
}
